import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');
const filter = require('lodash/filter');
const map = require('lodash/map');
const keys = require('lodash/keys');
const find = require('lodash/find');
const forEach = require('lodash/forEach');

const ServerRequest = require('../../actions/request');
const AssignmentActions = require('../../actions/AssignmentActions');
const GroupStore = require('../../stores/GroupStore');
const GroupActions = require('../../actions/GroupActions');
const StringConstants = require('../../constants/strings.js');

const propTypes = {
    activityID: PropTypes.string.isRequired,
    activityVersion: PropTypes.string.isRequired,
    onViewAssigment: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    activityName: PropTypes.string,
    hasCredentials: PropTypes.bool,
    missingCredentialsText: PropTypes.string,
};
const defaultProps = {
    activityName: 'Assignment',
    hasCredentials: false,
    missingCredentialsText: '',
};

class LocalAssignmentCreateUI extends React.Component {
    constructor(props) {
        super(props);

        let errorText = '';
        if (!props.hasCredentials) {
            errorText = props.missingCredentialsText;
        }

        const courseId = 'MZL_COURSE-' + String(uuid.v4());

        this.state = {
            showCreateDialog: true,
            courseId: courseId,
            group_id: -1,
            title: props.activityName,
            description: '',
            creatingAssignment: false,
            errorText: errorText,
            errorCode: '',
            resultText: '',
            resultRoute: '',
            retryCount: 0,
            emailOption: StringConstants.EMAIL_OPTIONS.optional, // Note: key == value,
            nameOption: StringConstants.NAME_OPTIONS.required,
            useAccessCodes: true,
            manuallyEnteredAccessCodes: false,
            accessCodeName: '',
            autoAdvance: false, // if true, 'skips' the assignment page (automatically proceeds to 'play' if possible)
            groupStoreState: GroupStore.getState(),
            students: [],
            waitingForStudents: false
        };

        this.closeCreateDialog = this.closeCreateDialog.bind(this);
        this.createAssignmentHandler = this.createAssignmentHandler.bind(this);
        this.onTitleChange = this.onTitleChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
        this.setNextNameOption = this.setNextNameOption.bind(this);
        this.setNextEmailOption = this.setNextEmailOption.bind(this);
        this.renderErrorDialog = this.renderErrorDialog.bind(this);
        this.renderWaitDialog = this.renderWaitDialog.bind(this);
        this.onViewCreatedAssignment = this.onViewCreatedAssignment.bind(this);
        this.renderResultDialog = this.renderResultDialog.bind(this);
        this.setUseAccessCode = this.setUseAccessCode.bind(this);
        this.setAutoAdvance = this.setAutoAdvance.bind(this);
        this.onSelectCourse = this.onSelectCourse.bind(this);

        this.unsubscribes = [
            GroupStore.listen(this.onGroupStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        GroupActions.getGroups(uuid.v4());
    }

    componentWillUnmount() {
        if (this.stopMe) {
            clearTimeout(this.stopMe);
        }

        this.unsubscribes.forEach(u => u());
    }

    onGroupStoreChange(state) {
        // console.log("onGroupStoreChange state.action: " + state.action);
        const group_id = this.state.group_id;
        const group_students = this.state.groupStoreState.group_users[group_id];
        const waitingForStudents = ((group_id >= 0) && (typeof group_students === 'undefined'));
        const students = group_students ? filter(group_students, {group_status:'ACTIVE'}) : [];

        const newState = {
            groupStoreState: state,
            students: map(students,'hash'),
            waitingForStudents: waitingForStudents
        };
        // console.log("LocalAssignmentCreateUI onGroupStoreChange newState: " + JSON.stringify(newState));
        this.setState(newState);
    }

    closeCreateDialog() {
        this.props.onClose();
    }

    createAssignmentHandler() {
        this.setState(
            {
                creatingAssignment: true
            }, () => {
                const assignmentHash = 'A-' + String(uuid.v4()); // In Soviet Russia, assignment creates you!
                const localAssignmentInstructorRoute = '/assignment/' + assignmentHash + '/mzl_instructor';
                const localAssignmentSetupUrl = GlobalConfig.ApiUrl + localAssignmentInstructorRoute;
                // Create the assignment in forge
                const params = {
                    assignmentHash: assignmentHash,
                    courseId: this.state.courseId,
                    group_id: this.state.group_id,
                    students: this.state.students,
                    title: this.state.title,
                    description: this.state.description,
                    joinOptions: {
                        nameOption: this.state.nameOption,
                        emailOption: this.state.emailOption,
                        useAccessCodes: this.state.useAccessCodes,
                        manuallyEnteredAccessCodes: this.state.manuallyEnteredAccessCodes,
                        accessCodeName: this.state.accessCodeName,
                        autoAdvance: this.state.autoAdvance,
                    }
                };
                ServerRequest.makeRequest(
                        `/authoring/create_mzl_assignment/${this.props.activityID}/${this.props.activityVersion}`,
                        'POST',
                        JSON.stringify(params)
                    )
                    .then((result) => {
                        const actionId = uuid.v4();
                        this.setState({
                            creatingAssignment: false,
                            resultText: "Assignment Created",
                            resultRoute: localAssignmentSetupUrl,
                            errorText: '',
                            errorCode: '',
                            actionId: actionId,
                        }, () => {
                            // update the assignment store
                            AssignmentActions.getLocalAssignments(actionId);
                        });
                    })
                    .catch((err) => {
                        if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
                            console.log(err);
                        }

                        this.setState({
                            creatingAssignment: false,
                            errorText: "Failed to complete assignment setup.",
                            errorCode: ''
                        });
                    });
            }
        );
    }

    onTitleChange(e) {
        this.setState({ title: e.target.value });
    }

    onDescriptionChange(e) {
        this.setState({ description: e.target.value });
    }

    setNextNameOption() {
        const k = keys(StringConstants.NAME_OPTIONS);
        let i = k.indexOf(this.state.nameOption);
        i = (i+1) % k.length;
        this.setState({ nameOption: k[i] });
    }

    setNextEmailOption() {
        const k = keys(StringConstants.EMAIL_OPTIONS);
        let i = k.indexOf(this.state.emailOption);
        i = (i+1) % k.length;
        this.setState({ emailOption: k[i] });
    }

    renderErrorDialog() {
        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                //container={mountNode}
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>Create Assignment</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.errorCode && ('Error ' + this.state.errorCode + ': ')}
                    {this.state.errorText}
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={this.closeCreateDialog}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    renderWaitDialog() {
        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                //container={mountNode}
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>Create Assignment in Google Classroom</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Creating Assignment...
                </Modal.Body>
            </Modal>
        );
    }

    onViewCreatedAssignment() {
        this.props.onViewAssigment(this.state.resultRoute);
    }

    renderResultDialog() {
        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                //container={mountNode}
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>Create Local Assignment</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.resultText}
                    <div className="seperator-thick"/>
                    {this.state.resultRoute && <Button onClick={this.onViewCreatedAssignment}>View</Button>}
                </Modal.Body>
            </Modal>
        );
    }

    setUseAccessCode(e) {
        this.setState({ useAccessCodes: e.target.checked });
    }
    
    setAutoAdvance(e) {
        this.setState({ autoAdvance: e.target.checked });
    }

    onSelectCourse(e) {
        const group_id = parseInt(e.target.value,10);
        const group_students = this.state.groupStoreState.group_users[group_id];
        const students = group_students ? filter(group_students, { group_status: 'ACTIVE' }) : [];
        const waitingForStudents = ((group_id >=0) && (typeof group_students === 'undefined'));
        const newState = {
            group_id: group_id,
            waitingForStudents: waitingForStudents,
            students: map(students,'hash'),
        };
        //console.log("LocalAssignmentCreateUI onSelectCourse newState: " + JSON.stringify(newState));
        this.setState(newState, () => {
            if (this.state.waitingForStudents) {
                GroupActions.getGroupUsers(uuid.v4(), { id: group_id });
            }
        });
    }
    
    onChangeAccessCodeMode=(e)=>{
        let useAccessCodes,manuallyEnteredAccessCodes;
        let accessCodeName = this.state.accessCodeName;
        switch(e.target.value) {
            case "generated":
                useAccessCodes = true;
                manuallyEnteredAccessCodes = false;
                break;
            case "off":
                useAccessCodes = false;
                manuallyEnteredAccessCodes = false;
                break;
            case "manual":
                useAccessCodes = true;
                manuallyEnteredAccessCodes = true;
                if (!accessCodeName) {
                    accessCodeName = 'Access Code';
                }
        }
        this.setState({useAccessCodes,manuallyEnteredAccessCodes,accessCodeName});
    }

    setAccessCodeName=(e)=>{
        let accessCodeName = e.target.value;
        this.setState({accessCodeName});
    }

    render() {
        const self = this;
        if (this.state.errorText) {
            return this.renderErrorDialog();
        }

        if (this.state.creatingAssignment) {
            return this.renderWaitDialog();
        }

        if (this.state.resultText) {
            return this.renderResultDialog();
        }

        let groupSelector = null;
        let anonOptions = null;
        if (this.state.groupStoreState && this.state.groupStoreState.groups && this.state.groupStoreState.groups.length > 0) {
            const courseOptions = [];
            // todo: what does this do? this.state.courses doesn't seem to be defined anywhere
            const selectedCourse = find(this.state.courses, { id: this.state.group_id });
            if (!selectedCourse) {
                courseOptions.push(<option key={'hidden_nothing'} disabled hidden style={{display: 'none'}} value=''></option>);
            }

            forEach(this.state.groupStoreState.groups,function(group, index) {
                const group_students = self.state.groupStoreState.group_users[group.id];
                let extra = '';
                let disabled = false; // TODO: ever used?
                if (group_students) {
                    var active_students = group_students ? filter(group_students,{group_status:'ACTIVE'}) : [];
                    if (active_students.length != 1) {
                        extra = " (" + active_students.length + " students)";
                    }
                    else {
                        extra = " (" + active_students.length + " student)";
                    }
                }

                courseOptions.push(<option key={group.id} value={group.id} disabled={disabled}>{group.name + extra}</option>);
            });
            courseOptions.push(<option key={'anon'} value={-1}>{'none (anonymous signup)'}</option>);
            groupSelector = (
                <div>
                    <label className="label-form">Group</label>
                    <br/>
                    <select value={self.state.group_id} onChange={this.onSelectCourse}>
                        {courseOptions}
                    </select>
                    <br/>
                </div>
            );
        }

        let accessCodeMode;
        let showAccessCodeName = false;
        if (this.state.useAccessCodes) {
            if (this.state.manuallyEnteredAccessCodes) {
                accessCodeMode = "manual";
                showAccessCodeName = true;
            }
            else {
                accessCodeMode = "generated";
            }
        }
        else {
            accessCodeMode = "generated";
        }

        if (this.state.group_id < 0) {
            anonOptions = (
                <div>
                    <div className="assignment-create-option-line">
                        <label className="label-form left-label">Name</label>
                        <button className="btn-options" onClick={this.setNextNameOption}>{this.state.nameOption}</button>
                    </div>

                    <div className="assignment-create-option-line">
                        <label className="label-form left-label">Email</label>
                        <button className="btn-options" onClick={this.setNextEmailOption}>{this.state.emailOption}</button>
                    </div>

                    <div className="assignment-create-option-line">
                        <label className="label-form right-label" htmlFor="cb-access-code">
                            {'Enable Access Codes: '}
                            <select id="cb-access-code" value={accessCodeMode} onChange={this.onChangeAccessCodeMode}>
                                <option hidden value="">{'Select...'}</option>
                                <option value="generated">{'Generated (default)'}</option>
                                <option value="off">{'None'}</option>
                                <option value="manual">{'Entered'}</option>
                            </select>
                        </label>
                        {/*
                        <input
                            id="cb-access-code"
                            type="checkbox"
                            checked={this.state.useAccessCodes}
                            onChange={this.setUseAccessCode}
                        />
                        */}
                    </div>
                    { showAccessCodeName ? 
                    <div className="assignment-create-option-line">
                        <label className="label-form right-label" htmlFor="cb-access-code-name">{'Access Code Name:'}</label>
                        <input
                            id="cb-access-code-name"
                            type="text"
                            value={this.state.accessCodeName}
                            onChange={this.setAccessCodeName}
                        />
                    </div>
                    : null }
                    
                    <div className="assignment-create-option-line">
                        <input
                            id="cb-auto-advance"
                            type="checkbox"
                            checked={this.state.autoAdvance}
                            onChange={this.setAutoAdvance}
                        />
                        <label className="label-form right-label" htmlFor="cb-auto-advance">Auto Play</label>
                    </div>
                    
                </div>
            );
        }

        return (
            <Modal
                show={this.state.showCreateDialog}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                //container={mountNode}
                onHide={this.closeCreateDialog}
            >
                <Modal.Header closeButton onHide={this.closeCreateDialog}>
                    <Modal.Title>Create Local Assignment</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group>
                        {groupSelector}
                        <Form.Label htmlFor="courseWorkTitle">Assignment Title</Form.Label>
                        <Form.Control id="courseWorkTitle" type='text' value={this.state.title} onChange={this.onTitleChange} />

                        <Form.Label htmlFor="courseWorkDescription">Assignment Description</Form.Label>
                        <Form.Control id="courseWorkDescription" type='text' value={this.state.description} onChange={this.onDescriptionChange} />
                        {anonOptions}
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button disabled={this.state.waitingForStudents} onClick={this.createAssignmentHandler}>Create</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

LocalAssignmentCreateUI.propTypes = propTypes;
LocalAssignmentCreateUI.defaultProps = defaultProps;

export default LocalAssignmentCreateUI;